import React from 'react';
import './styles.scss';
import { ActionCard } from '../ui';
import {
  useChatStore,
  useConfigStore,
  useInterfaceStore,
  useContextStore,
} from '@/hooks/stores';
import { useWidgetStore } from '@/hooks/stores/use-widget-store';
import { VIEW } from '@/types';
import { getHasCompletedForm } from '@/utils/form-state';
import Components from './components';

export const Home = () => {
  const {
    features: { home },
  } = useConfigStore();
  const { setWidgetActiveView } = useInterfaceStore();
  const { clearSession, sessionId, filledQuestionnaireData } = useChatStore();
  const { customContext } = useContextStore();
  const instanceId = useWidgetStore(state => state.instanceId);

  // Derive hasCompletedForm from existing state
  const hasCompletedForm = getHasCompletedForm(
    sessionId,
    filledQuestionnaireData,
    customContext.proposalId as string | undefined
  );

  const handleStartNewInquiry = () => {
    // Clear ALL session data (messages, form data, session, tokens, welcome back state)
    // This updates the Zustand store state FIRST
    clearSession();
    // Remove persisted storage AFTER clearing state using the correct dynamic key.
    // The key mirrors getStorageKey() in use-widget-store.ts:
    //   `peptalk-${instanceId}${sanitizedPath}`
    const sanitizedPath = window.location.pathname.replace(/[^a-zA-Z0-9]/g, '-');
    const storageKey = `peptalk-${instanceId}${sanitizedPath}`;
    localStorage.removeItem(storageKey);
  };

  return (
    <Components.Container className="peptalk-home">
      <ActionCard
        index={0}
        title={
          hasCompletedForm
            ? home.chatActionButton.titleWhenCompleted
            : home.chatActionButton.title
        }
        description={
          hasCompletedForm
            ? home.chatActionButton.descriptionWhenCompleted
            : home.chatActionButton.description
        }
        icon="PaperAirplane"
        onClick={() => {
          if (hasCompletedForm) {
            handleStartNewInquiry();
          }
          setTimeout(() => {
            setWidgetActiveView(VIEW.CHAT);
          });
        }}
      />
      <ActionCard
        index={1}
        title={home.linkButton.title}
        description={home.linkButton.description}
        icon="ArrowTopRightOnSquare"
        url={home.linkButton.url}
      />
    </Components.Container>
  );
};
